export const translations = {
  ar: {
    // General & Common
    appName: 'فاست لاين للتوصيل',
    tagline: 'منظومة إدارة التوصيل واللوجستيات',
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    search: 'بحث...',
    actions: 'الإجراءات',
    status: 'الحالة',
    active: 'نشط',
    inactive: 'غير نشط',
    all: 'الكل',
    filter: 'تصفية',
    refresh: 'تحديث',
    back: 'رجوع',
    confirm: 'تأكيد',
    close: 'إغلاق',
    notes: 'ملاحظات',
    date: 'التاريخ',
    phone: 'رقم الهاتف',
    name: 'الاسم',
    address: 'العنوان',
    details: 'التفاصيل',
    noData: 'لا توجد بيانات متاحة حالياً',
    currency: 'ج.م',
    systemOnline: 'النظام متصل',
    language: 'اللغة',
    arabic: 'العربية',
    english: 'English',
    themeMode: 'المظهر',
    darkMode: 'الوضع الليلي',
    lightMode: 'الوضع النهاري',
    logout: 'تسجيل الخروج',
    profile: 'الملف الشخصي',
    success: 'تمت العملية بنجاح',
    error: 'حدث خطأ ما',
    requiredField: 'هذا الحقل مطلوب',
    verificationStatus: 'حالة التوثيق',
    cashInHand: 'العهدة النقدية',
    completedOrders: 'الطلبات المكتملة',
    userAlreadyExists: 'المستخدم أو السجل موجود بالفعل في النظام',

    // Navigation / Sidebar
    nav: {
      operationsCategory: 'العمليات والتشغيل',
      liveOperations: 'غرفة العمليات الحية',
      ordersManagement: 'إدارة ومتابعة الطلبات',
      fleetCategory: 'الأسطول والمناديب',
      couriers: 'كباتن التوصيل والمناديب',
      vehicles: 'أسطول ومركبات الكباتن',
      courierDocs: 'توثيق واعتماد المستندات',
      partnersCategory: 'المطاعم والشركاء',
      restaurants: 'المطاعم وحسابات الفروع',
      pricingPlans: 'خطط الأسعار والعقود',
      financeCategory: 'المالية والتقارير',
      finance: 'المالية والتسويات والسلف',
      reports: 'التقارير وكشوف الحساب',
      settingsCategory: 'بيانات وإعدادات الشركة',
      companyProfile: 'الملف التعريفي والفروع',
      liveBadge: 'مباشر',
    },

    // Auth / Login
    login: {
      title: 'تسجيل الدخول',
      subtitle: 'لوحة تحكم وإدارة عمليات التوصيل',
      usernameLabel: 'اسم المستخدم أو الهاتف',
      usernamePlaceholder: '...أدخل اسم المستخدم',
      passwordLabel: 'كلمة المرور',
      passwordPlaceholder: '...أدخل كلمة المرور',
      submitBtn: 'تسجيل الدخول للنظام',
      rememberMe: 'تذكر بيانات الدخول',
      forgotPassword: 'نسيت كلمة المرور؟',
      fillRequired: 'يرجى إدخال اسم المستخدم وكلمة المرور',
      loginFailed: 'فشل تسجيل الدخول، يرجى التحقق من البيانات',
      connectionError: 'حدث خطأ أثناء الاتصال بالخادم',
      secureSystem: 'نظام تشغيل محمي ومشفر بالكامل',
    },

    // Couriers Page
    couriersPage: {
      title: 'كباتن التوصيل والمناديب',
      subtitle: 'إدارة وتعيين الكباتن وحسابات تطبيق Runner والأسطول',
      addCourierBtn: 'إضافة كابتن جديد',
      searchPlaceholder: 'بحث بالاسم، رقم الهاتف، أو الرقم القومي...',
      totalCouriers: 'إجمالي الكباتن',
      activeCouriers: 'الكباتن النشطين',
      onDutyCouriers: 'في الخدمة حالياً',
      suspendedCouriers: 'المتوقفين مؤقتاً',
      tableHeaders: {
        courier: 'الكابتن',
        phone: 'الهاتف',
        nationalId: 'الرقم القومي',
        vehicleType: 'نوع المركبة',
        plateNumber: 'رقم اللوحة',
        status: 'حالة الحساب',
        appAccount: 'حساب التطبيق',
        actions: 'الإجراءات',
      },
      addModal: {
        title: 'إضافة كابتن جديد للمنظومة',
        courierCode: 'كود الكابتن (Courier Code)',
        fullNameAr: 'الاسم باللغة العربية *',
        fullNameEn: 'الاسم باللغة الإنجليزية',
        mobile: 'رقم الموبايل الأساسي *',
        nationalId: 'الرقم القومي (14 رقم)',
        companyBranchId: 'فرع الشركة التابع له *',
        courierCategoryId: 'فئة / تصنيف الكابتن',
        creditLimit: 'الحد الائتماني للعهدة (ج.م)',
        maximumConcurrentOrders: 'الحد الأقصى للطلبات المتزامنة',
        employmentDate: 'تاريخ التعيين / بدء العمل',
        status: 'حالة الكابتن',
        saveBtn: 'حفظ وإضافة الكابتن',
        cancelBtn: 'إلغاء',
        categoryOptions: {
          fullTime: 'كابتن دائم (Full-Time)',
          freelancer: 'كابتن حر (Freelancer)',
          partTime: 'دوام جزئي (Part-Time)',
          vip: 'فئة مميزة (VIP Runner)',
        },
      },
      userModal: {
        title: 'حساب تطبيق المندوب (Runner Mobile Account)',
        courierLabel: 'الكابتن:',
        phoneLabel: 'الهاتف:',
        currentUsername: 'اسم المستخدم الحالي:',
        passwordTitle: 'إعادة تعيين كلمة المرور:',
        newPasswordLabel: 'كلمة المرور الجديدة',
        createUserTitle: 'إنشاء حساب جديد للمندوب على التطبيق:',
        passwordPrompt: 'كلمة المرور للدخول',
        createBtn: 'إنشاء الحساب وتفعيله',
        resetBtn: 'تحديث كلمة المرور',
        toggleActive: 'تبديل حالة الحساب (تفعيل / تعطيل)',
        accountCreatedMsg: 'تم إنشاء حساب المندوب بنجاح!',
        passwordResetMsg: 'تم تحديث كلمة المرور بنجاح!',
      },
      vehiclesModal: {
        title: 'إدارة مركبات الكابتن (Courier Vehicles)',
        courierLabel: 'الكابتن:',
        addVehicleTitle: 'إضافة مركبة جديدة للكابتن:',
        vehicleTypeLabel: 'نوع المركبة',
        plateNumberLabel: 'رقم اللوحة المعدنية',
        capacityOrdersLabel: 'سعة الطلبات (عدد)',
        licenseExpiresOnLabel: 'تاريخ انتهاء الرخصة',
        isPrimaryLabel: 'تعيين كمركبة أساسية',
        modelLabel: 'الموديل / الماركة',
        colorLabel: 'اللون',
        addBtn: 'إضافة المركبة',
        currentVehicles: 'المركبات المسجلة للكابتن:',
        noVehicles: 'لا توجد مركبات مسجلة لهذا الكابتن بعد',
        addedSuccess: 'تمت إضافة المركبة بنجاح!',
        updatedSuccess: 'تم تحديث بيانات المركبة!',
        primary: 'مركبة أساسية',
        active: 'نشطة',
        inactive: 'غير نشطة',
        ordersUnit: 'طلبات',
        expiresOn: 'انتهاء الرخصة',
      },
      messages: {
        fillRequired: 'يرجى ملء الاسم ورقم الهاتف والفرع',
        addSuccess: 'تمت إضافة الكابتن بنجاح!',
        addFail: 'فشل الإضافة:',
      },
    },

    // Vehicles Page
    vehiclesPage: {
      title: 'إدارة مركبات وأسطول التوصيل',
      subtitle: 'متابعة مركبات الكباتن، اللوحات المعدنية، وحالة المركبات',
      addVehicleBtn: 'إضافة مركبة جديدة',
      searchPlaceholder: 'بحث برقم اللوحة، الموديل، أو اسم الكابتن...',
      totalVehicles: 'إجمالي المركبات',
      activeVehicles: 'مركبات في الخدمة',
      motorcycles: 'موتوسيكلات وسكوتر',
      cars: 'سيارات وسيارات نقل',
      tableHeaders: {
        courier: 'الكابتن المخصص',
        vehicleType: 'نوع المركبة',
        plateNumber: 'رقم اللوحة المعدنية',
        model: 'الموديل / الماركة',
        color: 'اللون',
        status: 'الحالة',
        actions: 'الإجراءات',
      },
      addModal: {
        title: 'تسجيل وإضافة مركبة جديدة',
        courierSelect: 'اختر الكابتن المخصص له المركبة *',
        courierSelectPlaceholder: 'اختر الكابتن...',
        vehicleType: 'نوع المركبة *',
        plateNumber: 'رقم اللوحة المعدنية *',
        platePlaceholder: 'مثال: ط د ر 7842',
        model: 'الموديل / الطراز',
        modelPlaceholder: 'مثال: هوجن 3 / دايون / هيونداي',
        color: 'لون المركبة',
        colorPlaceholder: 'مثال: أسود / أحمر / أبيض',
        saveBtn: 'تسجيل المركبة',
      },
      types: {
        motorcycle: 'موتوسيكل',
        scooter: 'سكوتر',
        electricScooter: 'سكوتر كهربائي',
        car: 'سيارة',
        bicycle: 'عجلة',
        van: 'فان / نقل خفيف',
      },
    },

    // Home / Live Operations
    home: {
      title: 'غرفة العمليات والمتابعة الحية',
      subtitle: 'مراقبة حركة الأسطول ومسار الطلبات في الوقت الفعلي',
      totalOrdersToday: 'طلبات اليوم',
      activeDeliveries: 'قيد التوصيل الآن',
      availableCouriers: 'الكباتن المتاحين',
      delayedOrders: 'طلبات متأخرة',
      liveStreamTitle: 'بث ومتابعة الطلبات المباشر',
      liveOrdersFeed: 'تدفق الطلبات المباشر',
      pendingAssignments: 'طلبات بانتظار الإسناد',
      assignCourier: 'إسناد لكابتن',
      courierFleetStatus: 'حالة أسطول الكباتن',
      couriersOnDuty: 'كباتن الوردية النشطين',
      dispatchModalTitle: 'إسناد الطلب لكابتن (إسناد متوازي / مباشر)',
      selectCourierPrompt: 'اختر الكابتن الأقرب للطلب:',
      orderNumber: 'رقم الطلب:',
      pickupLocation: 'موقع الاستلام:',
      dropoffLocation: 'موقع التسليم:',
      totalAmount: 'القيمة الإجمالية:',
      deliveryFee: 'رسوم التوصيل:',
      dispatchBtn: 'تأكيد الإسناد المباشر',
      autoDispatchBtn: 'إسناد ذكي متوازي (Parallel Dispatch)',
      refreshData: 'تحديث البيانات',
    },

    // Orders Page
    ordersPage: {
      title: 'إدارة وسجل الطلبات',
      subtitle: 'عرض وتتبع وتصفية كافة طلبات المنظومة',
      searchOrders: 'بحث برقم الطلب، اسم العميل، أو المطعم...',
      allOrders: 'كافة الطلبات',
      pendingOrders: 'في انتظار الإسناد',
      inProgressOrders: 'قيد التوصيل',
      deliveredOrders: 'تم التوصيل',
      cancelledOrders: 'الملغية',
      pending: 'في الانتظار',
      pickedUp: 'تم الاستلام',
      delivered: 'تم التوصيل',
      cancelled: 'ملغي',
      orderNumber: 'رقم الطلب',
      restaurant: 'المطعم',
      customer: 'العميل',
      orderTotal: 'قيمة الطلب',
      courier: 'الكابتن',
      deliveryFee: 'رسوم التوصيل',
      tableHeaders: {
        orderId: 'رقم الطلب',
        restaurant: 'المطعم / الفرع',
        customer: 'العميل والعنوان',
        courier: 'الكابتن المسند',
        amount: 'قيمة الطلب',
        deliveryFee: 'خدمة التوصيل',
        status: 'حالة الطلب',
        createdAt: 'وقت الإنشاء',
        actions: 'الإجراءات',
      },
      detailsModal: {
        title: 'تفاصيل الطلب الكاملة',
        restaurantInfo: 'بيانات المطعم / الفرع',
        customerInfo: 'بيانات العميل والتوصيل',
        courierInfo: 'بيانات الكابتن',
        financials: 'البيانات المالية',
        stageHistory: 'سجل مراحل الطلب',
      },
    },

    // Courier Docs Page
    docsPage: {
      title: 'مراجعة وتوثيق مستندات الكباتن',
      subtitle: 'تدقيق واعتماد الهويات والرخص ومستندات المناديب',
      tableHeaders: {
        courier: 'الكابتن',
        docType: 'نوع المستند',
        docNumber: 'رقم المستند',
        status: 'الحالة',
        uploadDate: 'تاريخ الرفع',
        actions: 'الإجراءات',
      },
      reviewBtn: 'معاينة واعتماد',
      approveDoc: 'اعتماد وتوثيق المستند',
      rejectDoc: 'رفض المستند',
    },

    // Restaurants Page
    restaurantsPage: {
      title: 'المطاعم والشركاء',
      subtitle: 'إدارة المطاعم، الفروع، وحسابات بوابة المطاعم',
      addRestaurantBtn: 'إضافة مطعم جديد',
      tableHeaders: {
        restaurant: 'المطعم',
        contact: 'بيانات الاتصال',
        branches: 'عدد الفروع',
        pricingPlan: 'خطة التسعير',
        status: 'الحالة',
        portalUser: 'حساب البوابة',
        actions: 'الإجراءات',
      },
    },

    // Pricing Plans & Tariffs Hub
    pricingPage: {
      title: 'خطط الأسعار وقواعد التسعير',
      subtitle: 'إدارة خطط أسعار المطاعم، قواعد التسعير بالمناطق والمسافات، تعيين الفروع، ومناطق الخدمة',
      addPlanBtn: 'إضافة خطة تسعير جديدة',
      editPlanBtn: 'تعديل خطة التسعير',
      addRuleBtn: 'إضافة قاعدة تسعير',
      editRuleBtn: 'تعديل قاعدة التسعير',
      addAssignmentBtn: 'ربط خطة بفرع',
      addZoneBtn: 'إضافة منطقة خدمة',
      addCompPlanBtn: 'إضافة خطة تعويض كابتن',
      addCommissionRuleBtn: 'إضافة قاعدة عمولة',
      tabs: {
        plans: 'خطط أسعار المطاعم',
        rules: 'قواعد التسعير التفصيلية',
        assignments: 'ربط الفروع بالخطط',
        serviceZones: 'مناطق الخدمة الجغرافية',
        courierComp: 'خطط تعويض وعمولات الكباتن',
      },
      stats: {
        totalPlans: 'إجمالي خطط الأسعار',
        activePlans: 'الخطط النشطة السارية',
        totalRules: 'قواعد التسعير المسجلة',
        serviceZones: 'مناطق الخدمة المعتمدة',
      },
      fields: {
        planCode: 'كود الخطة',
        planNameAr: 'اسم الخطة (بالعربية)',
        effectiveFrom: 'ساري من تاريخ',
        effectiveTo: 'ساري إلى تاريخ',
        additionalOrderFeePercentage: 'نسبة رسوم الطلب الإضافي (%)',
        isActive: 'حالة الخطة',
        calculationType: 'نوع الحساب',
        fixedFee: 'الرسوم الثابتة',
        baseFee: 'الرسوم الأساسية',
        includedDistanceKm: 'المسافة المشمولة (كم)',
        additionalKmFee: 'رسوم الكيلومتر الإضافي',
        minimumFee: 'الحد الأدنى للرسوم',
        maximumFee: 'الحد الأقصى للرسوم',
        serviceZone: 'منطقة الخدمة',
        restaurantBranch: 'فرع المطعم (تخصيص)',
        zoneCode: 'كود المنطقة',
        zoneNameAr: 'اسم المنطقة (بالعربية)',
        zoneNameEn: 'اسم المنطقة (بالإنجليزية)',
        priority: 'الأولوية',
        latitude: 'خط العرض (Latitude)',
        longitude: 'خط الطول (Longitude)',
        hourlyRate: 'الأجر بالساعة',
        dailyRate: 'الأجر اليومي',
        additionalOrderPercentage: 'نسبة الطلبات الإضافية (%)',
        fixedCommission: 'العمولة الثابتة',
        baseCommission: 'العمولة الأساسية',
        additionalKmCommission: 'عمولة الكيلومتر الإضافي',
      },
      calcTypes: {
        fixed: 'رسوم ثابتة (Fixed Fee)',
        distance: 'حسب المسافة (Base + Per KM)',
      },
      tableHeaders: {
        planCode: 'كود الخطة',
        planName: 'اسم الخطة',
        validity: 'فترة السريان',
        additionalFee: 'رسوم إضافية',
        status: 'الحالة',
        rulesCount: 'القواعد',
        actions: 'الإجراءات',
        ruleId: 'رقم القاعدة',
        calcType: 'نوع الحساب',
        feesSummary: 'تفاصيل التسعير والرسوم',
        zone: 'المنطقة الجغرافية',
        branch: 'الفرع المستهدف',
        branchName: 'اسم الفرع',
        assignedPlan: 'الخطة المعينة',
        zoneCode: 'كود المنطقة',
        zoneName: 'اسم المنطقة',
        coordinates: 'الإحداثيات',
        priority: 'الأولوية',
        compPlan: 'خطة التعويض',
        hourlyDaily: 'الساعة / اليوم',
        pickupBranch: 'فرع الاستلام',
        destZone: 'منطقة التسليم',
      },
    },

    // Finance Page
    financePage: {
      title: 'المالية والتسويات اليومية',
      subtitle: 'متابعة العهد النقدية، السلف، وتسويات المطاعم والمناديب',
      recordAdvance: 'تسجيل سلفة / عهدة',
      settleAccount: 'إجراء تسوية حساب',
      totalCollectedCash: 'إجمالي النقدية المحصلة',
      dailySettlement: 'تسويات اليوم التشغيلية',
      courierDues: 'مستحقات المناديب',
      restaurantDues: 'حسابات ومستحقات المطاعم',
      companyProfit: 'أرباح وعمولات الشركة',
      tabs: {
        settlements: 'سجل التسويات المقفلة',
        advances: 'سجل السلف والخصومات',
        stats: 'المؤشرات المالية',
      },
      tableHeaders: {
        settlementNumber: 'رقم التسوية',
        advanceNumber: 'رقم السلفة',
        collectedCash: 'العهدة المحصلة',
        dueToCompany: 'المستحق للشركة',
        totalAdvance: 'إجمالي السلفة',
        collected: 'المحصل',
        remaining: 'المتبقي',
      },
    },

    // Company Profile
    companyPage: {
      title: 'الملف التعريفي للشركة وإعدادات التشغيل',
      subtitle: 'إدارة الهوية والبيانات وقواعد الإسناد الآلي',
      companyInfo: 'بيانات الشركة والهوية',
      dispatchRules: 'إعدادات وقواعد الإسناد الآلي',
      branches: 'فروع الشركة ونطاقات التغطية',
      saveChanges: 'حفظ التعديلات',
    },

    // Reports Page
    reportsPage: {
      title: 'التقارير التحليلية وكشوف الحساب',
      subtitle: 'متابعة مؤشرات الأداء، الأرباح، وكشوفات الحساب المالية الشاملة',
      exportExcel: 'تصدير تقرير إكسيل CSV',
      tabs: {
        company: 'تقرير الشركة الشامل',
        profitability: 'تقرير الأرباح والربحية',
        restaurant: 'كشف حساب مطعم',
        courier: 'كشف حساب كابتن',
      },
      selectRestaurant: 'اختر المطعم لعرض كشف الحساب',
      selectCourier: 'اختر الكابتن لعرض كشف الحساب',
      exportCsv: 'تصدير CSV',
    },
  },

  en: {
    // General & Common
    appName: 'FastLine Delivery',
    tagline: 'Delivery Operations & Logistics Management',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search...',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
    filter: 'Filter',
    refresh: 'Refresh',
    back: 'Back',
    confirm: 'Confirm',
    close: 'Close',
    notes: 'Notes',
    date: 'Date',
    phone: 'Phone Number',
    name: 'Name',
    address: 'Address',
    details: 'Details',
    noData: 'No data available currently',
    currency: 'EGP',
    systemOnline: 'System Online',
    language: 'Language',
    arabic: 'العربية',
    english: 'English',
    themeMode: 'Appearance',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    logout: 'Sign Out',
    profile: 'Profile',
    success: 'Operation completed successfully',
    error: 'An error occurred',
    requiredField: 'This field is required',
    verificationStatus: 'Verification',
    cashInHand: 'Cash in Hand',
    completedOrders: 'Completed Orders',
    userAlreadyExists: 'This user or record already exists in the system.',

    // Navigation / Sidebar
    nav: {
      operationsCategory: 'Operations & Dispatch',
      liveOperations: 'Live Operations Room',
      ordersManagement: 'Orders Management',
      fleetCategory: 'Fleet & Couriers',
      couriers: 'Couriers & Runners',
      vehicles: 'Vehicles & Fleet',
      courierDocs: 'Document Verification',
      partnersCategory: 'Partners & Restaurants',
      restaurants: 'Restaurants & Branches',
      pricingPlans: 'Pricing Plans & Contracts',
      financeCategory: 'Finance & Statements',
      finance: 'Finance & Settlements',
      reports: 'Reports & Statements',
      settingsCategory: 'Company & Settings',
      companyProfile: 'Company Profile & Info',
      liveBadge: 'Live',
    },

    // Auth / Login
    login: {
      title: 'Sign In',
      subtitle: 'FastLine Delivery Operations Dashboard',
      usernameLabel: 'Username or Phone',
      usernamePlaceholder: 'Enter your username...',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Enter your password...',
      submitBtn: 'Sign In to Dashboard',
      rememberMe: 'Remember me',
      forgotPassword: 'Forgot Password?',
      fillRequired: 'Please enter both username and password',
      loginFailed: 'Login failed, please check your credentials',
      connectionError: 'Network error connecting to server',
      secureSystem: 'Protected & encrypted logistics system',
    },

    // Couriers Page
    couriersPage: {
      title: 'Couriers & Runners Fleet',
      subtitle: 'Manage couriers, assignments, and Runner mobile accounts',
      addCourierBtn: 'Add New Courier',
      searchPlaceholder: 'Search by name, phone, or national ID...',
      totalCouriers: 'Total Couriers',
      activeCouriers: 'Active Couriers',
      onDutyCouriers: 'Currently On Duty',
      suspendedCouriers: 'Suspended',
      tableHeaders: {
        courier: 'Courier',
        phone: 'Phone',
        nationalId: 'National ID',
        vehicleType: 'Vehicle Type',
        plateNumber: 'Plate Number',
        status: 'Status',
        appAccount: 'Runner App Account',
        actions: 'Actions',
      },
      addModal: {
        title: 'Add New Courier to System',
        courierCode: 'Courier Code',
        fullNameAr: 'Full Name (Arabic) *',
        fullNameEn: 'Full Name (English)',
        mobile: 'Primary Mobile Number *',
        nationalId: 'National ID (14 Digits)',
        companyBranchId: 'Assigned Company Branch *',
        courierCategoryId: 'Courier Category / Tier',
        creditLimit: 'Credit / Cash Limit (EGP)',
        maximumConcurrentOrders: 'Max Concurrent Orders',
        employmentDate: 'Employment Date',
        status: 'Courier Status',
        saveBtn: 'Save & Add Courier',
        cancelBtn: 'Cancel',
        categoryOptions: {
          fullTime: 'Full-Time Courier',
          freelancer: 'Freelancer',
          partTime: 'Part-Time',
          vip: 'VIP Runner',
        },
      },
      userModal: {
        title: 'Runner Mobile App Account',
        courierLabel: 'Courier:',
        phoneLabel: 'Phone:',
        currentUsername: 'Current Username:',
        passwordTitle: 'Reset App Password:',
        newPasswordLabel: 'New Password',
        createUserTitle: 'Create Runner Mobile App Account:',
        passwordPrompt: 'App Password',
        createBtn: 'Create & Activate Account',
        resetBtn: 'Update Password',
        toggleActive: 'Toggle Account Status (Enable / Disable)',
        accountCreatedMsg: 'Runner account created successfully!',
        passwordResetMsg: 'Password updated successfully!',
      },
      vehiclesModal: {
        title: 'Courier Vehicles Management',
        courierLabel: 'Courier:',
        addVehicleTitle: 'Add New Vehicle for Courier:',
        vehicleTypeLabel: 'Vehicle Type',
        plateNumberLabel: 'Plate Number',
        capacityOrdersLabel: 'Order Capacity',
        licenseExpiresOnLabel: 'License Expiration Date',
        isPrimaryLabel: 'Set as Primary Vehicle',
        modelLabel: 'Model / Brand',
        colorLabel: 'Color',
        addBtn: 'Add Vehicle',
        currentVehicles: 'Registered Vehicles:',
        noVehicles: 'No vehicles registered for this courier yet',
        addedSuccess: 'Vehicle added successfully!',
        updatedSuccess: 'Vehicle details updated!',
        primary: 'Primary',
        active: 'Active',
        inactive: 'Inactive',
        ordersUnit: 'orders',
        expiresOn: 'Expires',
      },
      messages: {
        fillRequired: 'Please enter Arabic name, phone number, and select a branch',
        addSuccess: 'Courier added successfully!',
        addFail: 'Failed to add courier:',
      },
    },

    // Vehicles Page
    vehiclesPage: {
      title: 'Fleet & Vehicles Management',
      subtitle: 'Track courier vehicles, license plates, and operational status',
      addVehicleBtn: 'Register New Vehicle',
      searchPlaceholder: 'Search by plate number, model, or courier...',
      totalVehicles: 'Total Fleet Vehicles',
      activeVehicles: 'In-Service Vehicles',
      motorcycles: 'Motorcycles & Scooters',
      cars: 'Cars & Vans',
      tableHeaders: {
        courier: 'Assigned Courier',
        vehicleType: 'Vehicle Type',
        plateNumber: 'Plate Number',
        model: 'Model / Brand',
        color: 'Color',
        status: 'Status',
        actions: 'Actions',
      },
      addModal: {
        title: 'Register New Vehicle',
        courierSelect: 'Assigned Courier *',
        courierSelectPlaceholder: 'Select courier...',
        vehicleType: 'Vehicle Type *',
        plateNumber: 'Plate Number *',
        platePlaceholder: 'e.g. ABC 1234',
        model: 'Model / Brand',
        modelPlaceholder: 'e.g. Honda / Dayun / Hyundai',
        color: 'Vehicle Color',
        colorPlaceholder: 'e.g. Black / Red / White',
        saveBtn: 'Register Vehicle',
      },
      types: {
        motorcycle: 'Motorcycle',
        scooter: 'Scooter',
        electricScooter: 'Electric Scooter',
        car: 'Car',
        bicycle: 'Bicycle',
        van: 'Van / Light Truck',
      },
    },

    // Home / Live Operations
    home: {
      title: 'Live Operations & Dispatch Room',
      subtitle: 'Real-time fleet tracking and active delivery pipeline',
      totalOrdersToday: "Today's Orders",
      activeDeliveries: 'In Delivery Now',
      availableCouriers: 'Available Couriers',
      delayedOrders: 'Delayed Orders',
      liveStreamTitle: 'Live Orders Stream & Feed',
      liveOrdersFeed: 'Live Orders Feed',
      pendingAssignments: 'Pending Assignments',
      assignCourier: 'Assign Courier',
      courierFleetStatus: 'Courier Fleet Status',
      couriersOnDuty: 'Active Shift Couriers',
      dispatchModalTitle: 'Dispatch Order to Courier',
      selectCourierPrompt: 'Select optimal courier for order:',
      orderNumber: 'Order #:',
      pickupLocation: 'Pickup Location:',
      dropoffLocation: 'Dropoff Location:',
      totalAmount: 'Total Amount:',
      deliveryFee: 'Delivery Fee:',
      dispatchBtn: 'Direct Dispatch',
      autoDispatchBtn: 'Smart Parallel Dispatch',
      refreshData: 'Refresh Data',
    },

    // Orders Page
    ordersPage: {
      title: 'Orders Management & History',
      subtitle: 'View, filter, and track all system orders',
      searchOrders: 'Search by order #, customer, or restaurant...',
      allOrders: 'All Orders',
      pendingOrders: 'Pending Dispatch',
      inProgressOrders: 'In Progress',
      deliveredOrders: 'Delivered',
      cancelledOrders: 'Cancelled',
      pending: 'Pending',
      pickedUp: 'Picked Up',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      orderNumber: 'Order Number',
      restaurant: 'Restaurant',
      customer: 'Customer',
      orderTotal: 'Order Total',
      courier: 'Courier',
      deliveryFee: 'Delivery Fee',
      tableHeaders: {
        orderId: 'Order ID',
        restaurant: 'Restaurant / Branch',
        customer: 'Customer & Address',
        courier: 'Assigned Courier',
        amount: 'Order Value',
        deliveryFee: 'Delivery Fee',
        status: 'Order Status',
        createdAt: 'Created At',
        actions: 'Actions',
      },
      detailsModal: {
        title: 'Full Order Details',
        restaurantInfo: 'Restaurant / Branch Info',
        customerInfo: 'Customer & Delivery Info',
        courierInfo: 'Courier Info',
        financials: 'Financials',
        stageHistory: 'Stage History & Timeline',
      },
    },

    // Courier Docs Page
    docsPage: {
      title: 'Courier Documents & Verification',
      subtitle: 'Review and approve courier national IDs, licenses, and background checks',
      tableHeaders: {
        courier: 'Courier',
        docType: 'Document Type',
        docNumber: 'Document Number',
        status: 'Status',
        uploadDate: 'Upload Date',
        actions: 'Actions',
      },
      reviewBtn: 'Review & Verify',
      approveDoc: 'Approve & Verify',
      rejectDoc: 'Reject Document',
    },

    // Restaurants Page
    restaurantsPage: {
      title: 'Restaurants & Partners',
      subtitle: 'Manage restaurant partners, branches, and portal user accounts',
      addRestaurantBtn: 'Add New Restaurant',
      tableHeaders: {
        restaurant: 'Restaurant',
        contact: 'Contact Info',
        branches: 'Branches Count',
        pricingPlan: 'Pricing Plan',
        status: 'Status',
        portalUser: 'Portal Account',
        actions: 'Actions',
      },
    },

    // Pricing Plans & Tariffs Hub
    pricingPage: {
      title: 'Pricing Plans & Tariffs Hub',
      subtitle: 'Manage restaurant pricing plans, distance & zone rules, branch assignments, and service zones',
      addPlanBtn: 'Add Pricing Plan',
      editPlanBtn: 'Edit Pricing Plan',
      addRuleBtn: 'Add Pricing Rule',
      editRuleBtn: 'Edit Pricing Rule',
      addAssignmentBtn: 'Assign Plan to Branch',
      addZoneBtn: 'Add Service Zone',
      addCompPlanBtn: 'Add Courier Compensation Plan',
      addCommissionRuleBtn: 'Add Commission Rule',
      tabs: {
        plans: 'Restaurant Pricing Plans',
        rules: 'Pricing Rules',
        assignments: 'Branch Plan Assignments',
        serviceZones: 'Geographic Service Zones',
        courierComp: 'Courier Compensation & Commissions',
      },
      stats: {
        totalPlans: 'Total Pricing Plans',
        activePlans: 'Active Plans',
        totalRules: 'Defined Pricing Rules',
        serviceZones: 'Active Service Zones',
      },
      fields: {
        planCode: 'Plan Code',
        planNameAr: 'Plan Name (Arabic)',
        effectiveFrom: 'Effective From',
        effectiveTo: 'Effective To',
        additionalOrderFeePercentage: 'Additional Order Fee (%)',
        isActive: 'Status',
        calculationType: 'Calculation Type',
        fixedFee: 'Fixed Fee',
        baseFee: 'Base Fee',
        includedDistanceKm: 'Included Distance (KM)',
        additionalKmFee: 'Additional KM Fee',
        minimumFee: 'Minimum Fee',
        maximumFee: 'Maximum Fee',
        serviceZone: 'Service Zone',
        restaurantBranch: 'Restaurant Branch (Override)',
        zoneCode: 'Zone Code',
        zoneNameAr: 'Zone Name (Arabic)',
        zoneNameEn: 'Zone Name (English)',
        priority: 'Priority',
        latitude: 'Center Latitude',
        longitude: 'Center Longitude',
        hourlyRate: 'Hourly Rate',
        dailyRate: 'Daily Rate',
        additionalOrderPercentage: 'Additional Order Percentage (%)',
        fixedCommission: 'Fixed Commission',
        baseCommission: 'Base Commission',
        additionalKmCommission: 'Additional KM Commission',
      },
      calcTypes: {
        fixed: 'Fixed Fee',
        distance: 'Distance-based (Base + Per KM)',
      },
      tableHeaders: {
        planCode: 'Plan Code',
        planName: 'Plan Name',
        validity: 'Validity Period',
        additionalFee: 'Additional Fee',
        status: 'Status',
        rulesCount: 'Rules',
        actions: 'Actions',
        ruleId: 'Rule #',
        calcType: 'Calculation Type',
        feesSummary: 'Pricing Details',
        zone: 'Service Zone',
        branch: 'Target Branch',
        branchName: 'Branch Name',
        assignedPlan: 'Assigned Plan',
        zoneCode: 'Zone Code',
        zoneName: 'Zone Name',
        coordinates: 'Coordinates',
        priority: 'Priority',
        compPlan: 'Compensation Plan',
        hourlyDaily: 'Hourly / Daily Rate',
        pickupBranch: 'Pickup Branch',
        destZone: 'Delivery Zone',
      },
    },

    // Finance Page
    financePage: {
      title: 'Financials & Daily Settlements',
      subtitle: 'Track courier cash in hand, advances, and restaurant settlements',
      recordAdvance: 'Record Advance / Float',
      settleAccount: 'Settle Account',
      totalCollectedCash: 'Total Collected Cash',
      dailySettlement: 'Daily Operational Settlements',
      courierDues: 'Courier Dues',
      restaurantDues: 'Restaurant Accounts & Dues',
      companyProfit: 'Company Commission & Profit',
      tabs: {
        settlements: 'Settlements History',
        advances: 'Advances & Deductions',
        stats: 'Financial KPI Metrics',
      },
      tableHeaders: {
        settlementNumber: 'Settlement #',
        advanceNumber: 'Advance #',
        collectedCash: 'Collected Cash',
        dueToCompany: 'Due to Company',
        totalAdvance: 'Total Advance',
        collected: 'Collected',
        remaining: 'Remaining',
      },
    },

    // Company Profile
    companyPage: {
      title: 'Company Profile & Operational Rules',
      subtitle: 'Manage branding, branches, and automatic dispatch algorithms',
      companyInfo: 'Company Branding & Details',
      dispatchRules: 'Dispatch Rules & Limits',
      branches: 'Company Branches & Zones',
      saveChanges: 'Save Changes',
    },

    // Reports Page
    reportsPage: {
      title: 'Analytical Reports & Account Statements',
      subtitle: 'Monitor revenue, commissions, and comprehensive statements',
      exportExcel: 'Export Excel CSV',
      tabs: {
        company: 'Company Overview',
        profitability: 'Profitability Report',
        restaurant: 'Restaurant Statement',
        courier: 'Courier Statement',
      },
      selectRestaurant: 'Select Restaurant for Statement',
      selectCourier: 'Select Courier for Statement',
      exportCsv: 'Export CSV',
    },
  },
};
